import { Section, Tab } from '../../api/appConfiguration/types';

export const canDeleteOrChangeSection = ({
  appConfiguration,
  section,
}: {
  appConfiguration?: Tab[];
  section?: Section;
}) => {
  const allSections = appConfiguration?.reduce((res, item) => res?.concat(item?.sections), [] as Section[]);

  switch (section?.type) {
    case 'todaysPicks':
    case 'updateData':
    case 'survey':
    case 'journal':
    case 'journalTab':
    case 'unlockSubscription':
    case 'yourPurchases':
    case 'gifts':
    case 'stats':
    case 'recentlyPlayed':
    case 'recentlyPlayedAuthors':
      const result = allSections?.filter((item) => item?.type === section?.type);
      return result && result?.length > 1;
  }

  return true;
};
